import Grid from "@mui/material/Grid";
import { styled } from "@mui/system";

const StyledFormGrid = styled(Grid)(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
  padding: '0px 32px',
  gap: 20
  // borderTop:  `1px solid ${theme.palette.border.input}`,
  // borderBottom:  `1px solid ${theme.palette.border.input}`
}));
export default StyledFormGrid;

export const POCFormGrid = styled(Grid)(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
}));
